/* eslint-disable prefer-template */

const hexToRgb = (hex, alpha = 1, numbersOnly = false) => {
    if (!hex) return '#ffffff';
    const parsedHex = hex.match(hex.length <= 4 ? /\w/g : /\w\w/g);
    if (!parsedHex) return '#ffffff';
    const [r, g, b] = parsedHex.map(x => parseInt(x.length < 2 ? `${x}${x}` : x, 16));
    if (numbersOnly) {
        return `${r},${g},${b}`;
    }
    return `rgba(${r},${g},${b},${alpha})`;
};

export default hexToRgb;
